import { render, staticRenderFns } from "./InfoCommande.vue?vue&type=template&id=fc1ff1c8&scoped=true"
import script from "./InfoCommande.vue?vue&type=script&lang=js"
export * from "./InfoCommande.vue?vue&type=script&lang=js"
import style0 from "./InfoCommande.vue?vue&type=style&index=0&id=fc1ff1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1ff1c8",
  null
  
)

export default component.exports